(function() {

  em.header = {};

  var el = document.querySelector(".js-header");

  em.header.init = function() {

    em.header.setupHeadroom();
    em.header.handleSearchBG();

  };

  em.header.setupHeadroom = function() {
    if (el === null) { return false; }

    var headroom = new Headroom(el, {
      offset: 110,
      tolerance: 5,
      onUnpin: function () {
        if (em.header.isMobileMenuOpen()) {
          this.elem.classList.remove(this.classes.unpinned);
          this.elem.classList.add(this.classes.pinned);
        } else {
          this.elem.classList.add(this.classes.unpinned);
          this.elem.classList.remove(this.classes.pinned);
        }
      },
    });

    headroom.init();
  };

  em.header.isMobileMenuOpen = function() {
    return false;
  };

  em.header.handleSearchBG = function() {

    var form = document.querySelector("#search");
    form.addEventListener('focusin', function(e) {
      e.target.style.background = '#fff';
    });
    
    form.addEventListener('focusout', function(e) {
      var inputS = document.querySelector('#s');
      if (inputS.value.length > 0){
        e.target.style.background = '#fff';
      } else {
        e.target.style.background = 'transparent';
      }
    });
  };

})();